import './microcertificate.scss';

import { connector } from '@descomplica/microfrontend-react';
import { t } from 'i18next';
import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import NotFound from '@/presentation/components/not-found/not-found';

import Icon from '../../components/icon/icon';
import CenteredLayout from '../../components/layout/centered-layout/centered-layout';
import OutlineButton from '../../components/outline-button/outline-button';
import CoursePageLink from './components/course-page-link/course-page-link';
import {
  AvaliableFormats,
  MicrocertificateViewModel,
} from './microcertificate.vm';

export const Microcertificate: FC<{ vm: MicrocertificateViewModel }> = ({
  vm,
}) => {
  const { microcertHash } = useParams();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    // In order to support PR-env testing, we may use the query param "microcertHash"
    const queryMicrocertHash = queryParams.get('microcertHash');

    vm.setMicrocertificateHash(microcertHash || queryMicrocertHash || '');
  }, []);

  if (vm.notFound) return <NotFound />;
  if (!vm.microcertificateHash) return <></>;

  return (
    <CenteredLayout>
      <CoursePageLink
        display={!!vm.coursePageLink}
        url={vm.coursePageLink}
        onClick={() => {
          vm.trackNavigateToCoursePage();
        }}
      />
      <img
        tabIndex={2}
        className="microcertificate"
        src={vm.microcertificatePreviewUrl}
      />
      <section
        className="download-section"
        aria-label={t('pages.microcertificate.downloadCertificate') || ''}
      >
        <h1 className="download-section__header">
          {t('pages.microcertificate.downloadCertificate')}
        </h1>
        <div role="group" className="download-section__buttons-group">
          <OutlineButton
            tabIndex={3}
            ariaLabel={t('pages.microcertificate.downloadAsPDF') || ''}
            onClick={() => vm.downloadMicrocertificate(AvaliableFormats.PDF)}
            icon={<Icon name="pdf" />}
          >
            {t('pages.microcertificate.pdf')}
          </OutlineButton>
          <OutlineButton
            tabIndex={4}
            ariaLabel={t('pages.microcertificate.downloadAsPDF') || ''}
            onClick={() => vm.downloadMicrocertificate(AvaliableFormats.PNG)}
            icon={<Icon name="image" />}
          >
            {t('pages.microcertificate.png')}
          </OutlineButton>
        </div>
      </section>
    </CenteredLayout>
  );
};

export default connector.buildConnectedComponent(
  Microcertificate,
  MicrocertificateViewModel,
);
